const METRIC_COLORS = {
  http_requests: '#1890ff',
  error_rate: '#f5222d',
  latency_p50: '#52c41a',
  latency_p95: '#faad14',
  latency_p99: '#722ed1',
  cpu: '#13c2c2',
  memory: '#eb2f96',
  connections: '#fa8c16'
};

const METRIC_LABELS = {
  http_requests: 'HTTP Requests',
  error_rate: 'Error Rate',
  latency_p50: 'P50 Latency',
  latency_p95: 'P95 Latency',
  latency_p99: 'P99 Latency',
  cpu: 'CPU Usage',
  memory: 'Memory Usage',
  connections: 'Connections'
};

export const metricsLineChart = (data = [], selectedMetrics = ['http_requests']) => {
  const timestamps = data.map(d => d.timestamp);
  const useDataZoom = data.length > 60;

  const series = selectedMetrics.map(metric => ({
    name: METRIC_LABELS[metric] || metric,
    type: 'line',
    smooth: true,
    showSymbol: false,
    data: data.map(d => d[metric] ?? 0),
    lineStyle: { width: 2 },
    itemStyle: { color: METRIC_COLORS[metric] || '#1890ff' }
  }));

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' }
    },
    legend: {
      data: selectedMetrics.map(m => METRIC_LABELS[m] || m),
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '3%',
      top: '10%',
      bottom: useDataZoom ? '18%' : '12%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: timestamps,
      boundaryGap: false,
      axisLabel: { fontSize: 10 }
    },
    yAxis: {
      type: 'value',
      axisLabel: { fontSize: 10 }
    },
    dataZoom: useDataZoom ? [
      { type: 'inside', xAxisIndex: 0, start: 60, end: 100 },
      { type: 'slider', show: true, xAxisIndex: 0, start: 60, end: 100, height: 20 }
    ] : [],
    series
  };
};
